import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IAiReport } from '../../../../shared/components/ai-report-view/ai-report-view.interface';
import { IBaseResponse } from '../../../../utilities/http-utilities.service';
import { IAiAssistRequest, IAiAssistSuggestion, IItemAiReportRequest } from './ai-assist-dialog.interface';

/** The item AI dialog's two calls; nothing is saved by either. */
@Injectable()
export class AiAssistDialogService {
  private readonly http = inject(HttpClient);

  /** A title and/or description for the form, from the draft (it may hold unsaved changes). */
  public requestSuggestion(request: IAiAssistRequest): Observable<IBaseResponse<IAiAssistSuggestion>> {
    return this.http.post<IBaseResponse<IAiAssistSuggestion>>('items/ai-assist', request);
  }

  /** A report to read on the saved item; only its id goes in the URL, the API reads the item itself. */
  public requestReport(itemId: number, request: IItemAiReportRequest): Observable<IBaseResponse<IAiReport>> {
    return this.http.post<IBaseResponse<IAiReport>>(`items/${itemId}/ai-report`, request);
  }
}
